import React from "react";
import {useAppContext} from "../../context/AppContext";
import ProjectInfo from "../ProjectInfo";

// Overview sekmesi — yalnizca ProjectInfo gosterir (ozet panelleri YOK).
// Check  -> base projenin bilgisi.
// Comparison -> base + compare yan yana.
export default function OverviewTab() {
    const {getSelectedHistory, resolveHistorySelection} = useAppContext()
    const history = getSelectedHistory()
    const sel = resolveHistorySelection(history) || {base: {}, compare: {}}
    const base = sel.base || {}
    const compare = sel.compare || {}

    const infoProps = (side) => ({
        report: false,
        showNotes: false,
        folderName: side.project?.information?.folderName,
        title: side.project?.information?.title,
        descriptions: side.project?.information?.descriptions || [],
        planTitle: side.plan?.plan?.title,
        version:
            side.project?.projectFiles &&
            side.project?.projectFiles.length > 0 &&
            side.plan?.plan?.version,
    })

    return (
        <div style={{padding: 8}}>
            {history?.type === "Comparison" ? (
                <div style={{display: "flex", alignItems: "start", gap: 16}}>
                    <ProjectInfo {...infoProps(base)} />
                    <ProjectInfo {...infoProps(compare)} />
                </div>
            ) : (
                <ProjectInfo {...infoProps(base)} />
            )}
        </div>
    )
}
